import { createAction } from 'redux-actions';

export const updateOutreachAggregateReportQuery = createAction(
  'UPDATE_OUTREACH_AGGREGATE_REPORT_QUERY'
);
